import axios from 'axios'
function dealWithResult (data, resolve, reject) {
  if (data.data.code && parseInt(data.data.code) === 100) {
    resolve(data.data.data)
  } else {
    // TODO special code
    window.$router.replace
    reject(data.data.message)
  }
}

function dealWithError (data, resolve, reject) {
  reject(data.status + ' ' + data.statusText)
}

function post (url, body, token, param) {
  return new Promise(function (resolve, reject) {
    axios.post(`/vue${url}`, body, {params: param, headers: {'token': (!token ? '' : token), 'locale': 'zh_CN'}}).then((response) => {
      dealWithResult(response, resolve, reject)
      // resolve()
    }, (response) => {
      dealWithError(response, resolve, reject)
      // reject()
    })
  })
}

function get (url, param, token) {
  return new Promise(function (resolve, reject) {
    axios.get(`/vue${url}`, {params: param, headers: {'token': (!token ? '' : token), 'locale': 'zh_CN'}}).then((response) => {
      dealWithResult(response, resolve, reject)
    }).catch((error) => {
      dealWithError(error, resolve, reject)
    })
  })
}

function deleted (url, param, token) {
  return new Promise(function (resolve, reject) {
    axios.delete(`/vue${url}`, {params: param, headers: {'token': (!token ? '' : token), 'locale': 'zh_CN'}}).then((response) => {
      dealWithResult(response, resolve, reject)
    }, (response) => {
      dealWithError(response, resolve, reject)
    })
  })
}

export default {
  activateAccount (param) {
    return post('/activateAccount', param)
  },
  login (info) {
    return post('/login', info)
  },
  getPeriods (userInfo) {
    return get('/period', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId })
  },
  getHomePage (userInfo) {
    return get('/getHomePage', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, hallId: userInfo.hallId })
  },
  getRecords (userInfo, type, page) {
    return get('/getRecords', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, type: type, page: page })
  },
  getOrderDetail (userInfo, orderId) {
    return get(`/getOrderDetail`, {token: userInfo.token, company: userInfo.companyId, user: userInfo.userId, orderId: orderId})
  },
  getBalance (userInfo) {
    return get('/balance', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId })
  },
  getPeriodMenus (userInfo, hallId, periodPlanId) {
    return get(`/getPeriodMenus?userId=${userInfo.userId}&companyId=${userInfo.companyId}`, {hallId: hallId, periodPlanId: periodPlanId}, userInfo.token)
  },
  addOrder (userInfo, param) {
    return post(`/addOrder`, param, userInfo.token)
  },
  getPayInfo (userInfo, orderIds, payType, companyId) {
    return get(`/pay?user=${userInfo.userId}&openId=${userInfo.openId}&orderIds=${orderIds}&payType=${payType}&companyId=${companyId}`, {}, userInfo.token)
  },
  modifyPwd (param) {
    return get('/modifyPwd', param, param.token)
  },
  deleteOrder (userInfo, orderId) {
    return deleted('/deleteOrder', {token: userInfo.token, companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId})
  },
  getAddressList (companyId) {
    return get('/getAddressList', {companyId: companyId})
  },
  transferBedWithAddress (userInfo, orderId, address) {
    return get('/transferBedWithAddress', {companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId, address: address}, userInfo.token)
  },
  getPatientInfo (userInfo, patientNo) {
    return get(`/getPatientInfo`, {userId: userInfo.userId, companyId: userInfo.companyId, patientNo: patientNo}, userInfo.token)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js